import { setLatestTraceId } from '../actions/publicActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(setLatestTraceId, function (actionMessage) {
    getStore().latestTraceId = actionMessage.latestTraceId;
});
//# sourceMappingURL=setLatestTraceId.js.map